<template>
  <app-btn class="user-badge" target="_blank" :href="link" :class="classes">
    <div class="user-badge__avatar">
      <img
        class="user-badge__avatar-img"
        v-if="user && user.avatar"
        :src="user.avatar"
        alt="Аватар пользователя"
      />
      <SvgIcon v-else size="80%" name="user-light" />
    </div>
    <div v-if="user" class="user-badge__info">
      <div class="user-badge__name ellipsis">{{ user.nickname }}</div>
      <div class="user-badge__country ellipsis">
        {{ user.country | country }}
      </div>
    </div>
  </app-btn>
</template>

<script>
export default {
  name: "UserBadge",
  props: {
    user: Object,
    avatarColor: {
      type: String,
      default: "blue",
      validator: val => ["blue", "red"].includes(val)
    }
  },
  computed: {
    classes() {
      return {
        [`user-badge_${this.avatarColor}`]: !!this.avatarColor
      };
    },
    link() {
      const { user } = this;
      return (
        (user &&
          user.steam_id64 &&
          `https://steamcommunity.com/profiles/${user.steam_id64}/`) ||
        null
      );
    }
  }
};
</script>

<style lang="scss">
$p: ".user-badge";

.user-badge {
  background: rgba(0, 10, 37, 0.6);
  padding: 10px 16px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-flow: row;
  transition: 0.3s;
  pointer-events: none;

  .btn__content {
    max-width: 100%;
  }

  &[href] {
    pointer-events: auto;
  }

  &[href]:hover {
    box-shadow: 0px 0px 20px rgba(60, 171, 221, 0.75);
  }

  &__avatar {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border: 2px solid transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
  }

  &__avatar-img {
    display: block;
    width: 100%;
  }

  &__info {
    line-height: 1.15;
    text-align: left;
    max-width: calc(100% - 56px);
  }

  &__name {
    font-weight: 800;
    font-size: 14px;
    color: #fff;
    text-transform: uppercase;
    max-width: 100%;
  }

  &__country {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.5);
    text-transform: none;
    font-weight: 500;
    max-width: 100%;
  }

  &_red {
    #{$p}__avatar {
      background: #811314;
      border-color: #e72f31;
      color: rgba(231, 47, 49, 0.8);
    }
  }

  &_blue {
    #{$p}__avatar {
      background: #0d5577;
      border-color: #1480b2;
      color: rgba(20, 128, 178, 0.8);
    }
  }
}
</style>
